export default __webpack_public_path__ + "static/valve-0fe5bdaf3af111e406ceeb9df8126be4.png";